import axios from 'utils/axios';
import { useCallback, useEffect, useState } from 'react'
import { ITag, ITagId } from '../types/tag';
import { ITags } from '../types/tags';

// type HookNotReadyResult = { ready: false };
// type HookReadyResult<T extends object> = { ready: true } & T;
// type HookResult<T extends object> = HookReadyResult<T> | HookNotReadyResult;

export interface UseTagsState {
    fetchInProgress: boolean;
    fetch(): void;
    createTagInProgress: boolean;
    createTag(tagFields: Partial<ITag>): Promise<number>;
    updateTagInProgress: boolean;
    updateTag(tagID: ITagId, tagFields: Partial<ITag>): Promise<void>;
    deleteTagInProgress: boolean;
    deleteTag(tagID: ITagId): void;
    tags: ITags;
    ready: boolean;
};

export const useTags = (deleted: boolean = false) => {
    const [state, setState] = useState<UseTagsState>({
        fetchInProgress: false,
        fetch: null,
        createTagInProgress: false,
        createTag: null,
        updateTagInProgress: false,
        updateTag: null,
        deleteTagInProgress: false,
        deleteTag: null,
        tags: null,
        ready: false
    });

    const fetch = useCallback(async () => {
        setState(s => ({ ...s, fetchInProgress: true }))
        const response = await axios.get<any>('/berryAPI/tags')
        setState(s => ({
          ...s,
          fetchInProgress: false,
          tags: response.data.tags,
          ready: true
        }))
    }, [setState])
		
		const createTag = async (tagFields: any) => {
			setState(s => ({ ...s, createTagInProgress: true }))
			return await axios
				.post(`/berryAPI/tag`, tagFields)
				.then(async (response)=>{
						if (response.status = 200) {
							setState(s => ({
								...s,
								createTagInProgress: false,
                tags: response.data.tags
							}));
              return response.data.newTagID;
						}
					})
					.catch ((error)=>{
						// Error
						console.log(error);
						setState(s => ({ ...s, createTagInProgress: false }));
						throw error;
				});
    }

    const updateTag = async (tagID: ITagId, tagFields: any) => {
        setState((s) => ({ ...s, updateTagInProgress: true }));

        return await axios
            .put(`/berryAPI/tag/${tagID}`, tagFields)
            .then(async (response) => {
                if (response.status = 200) {
                    setState((s) => ({
                        ...s,
                        updateTagInProgress: false,
                        tags: response.data.tags
                    }));
                }
            })
            .catch((error) => {
                console.log(error);
                setState((s) => ({ ...s, updateTagInProgress: false }));
                throw error;
            });
    }

    const deleteTag = async (tagID: ITagId) => {
        setState((s) => ({ ...s, deleteTagInProgress: true }));
        
        const response = await axios.delete(`/berryAPI/tag/${tagID}`);
        
        if (response.status = 200) {
          setState((s) => ({
            ...s,
            deleteTagInProgress: false,
            tags: response.data.tags
          }));
        }
        
    }

    useEffect(() => {
        fetch()
    }, [])

      return { ...state, fetch, createTag, updateTag, deleteTag }
    };
